module.exports = __webpack_public_path__ + "static/media/viber_logo.8612c370.svg";